let apiPromise;

function loadTurnstile(nonce) {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!apiPromise) {
    apiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.nonce = nonce;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => {
        script.remove();
        apiPromise = undefined;
        reject(new Error('Security check could not load.'));
      };
      document.head.appendChild(script);
    });
  }
  return apiPromise;
}

export async function setupTurnstile() {
  const containers = document.querySelectorAll('[data-js="turnstile"]');
  if (containers.length === 0) return;

  try {
    const turnstile = await loadTurnstile(containers[0].dataset.nonce);
    containers.forEach((container) => {
      const widgetId = turnstile.render(container.querySelector('[data-js="turnstile-widget"]'), {
        sitekey: container.dataset.siteKey,
        action: container.dataset.action,
        'response-field-name': 'turnstile_token',
        'refresh-expired': 'auto',
        appearance: 'interaction-only',
        'before-interactive-callback': () => container.classList.add('c-turnstile--interactive'),
        theme: document.documentElement.dataset.bsTheme,
        size: 'flexible',
      });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) turnstile.reset(widgetId);
      });
    });
  } catch {
    // Cloudflare owns the UI, so an unusable challenge shows nothing; the tokenless
    // submit is rejected server-side and rendered as an ordinary form error.
  }
}

// Module scripts and SetupForms' Vue mount finish before DOMContentLoaded. Rendering
// earlier lets Vue discard the iframe and its response input when it mounts the form.
if (document.readyState === 'complete') {
  setupTurnstile();
} else {
  document.addEventListener('DOMContentLoaded', setupTurnstile, {once: true});
}
